var React = require('react');

function Apollo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M778.243,315.672h5.52L774.949,292.8h-6.1l-8.812,22.873h5.52l1.441-3.875h8.328l-1.508-4.287h-5.482l3.566-9.843Zm18.206-16.935a1.329,1.329,0,0,0-2.561.711,22.972,22.972,0,1,1-7.463-11.5,3.194,3.194,0,1,0,1.975-1.812,25.529,25.529,0,1,0,8.049,12.605Z","transform":"translate(-746.225 -280)"}));
}

Apollo.defaultProps = {"width":"51.156","height":"51.156","viewBox":"0 0 51.156 51.156"};

module.exports = Apollo;

Apollo.default = Apollo;
